/**
 * @file 请求调度兼容层
 * @description 保留请求优先级 API，当前交由 HTTP/2 与浏览器原生并发控制处理。
 */

/** 请求优先级类型，保留给调用方标记交互、普通、背景请求 */
export type RequestPriority = 'interactive' | 'normal' | 'background'

/**
 * 获取请求槽位。
 *
 * 全站已走 HTTP/2，不再使用前端人为并发池；请求并发交给浏览器、代理和服务端处理。
 * @param _priority 请求优先级，保留用于兼容旧调用点。
 * @returns 已立即完成的 Promise。
 */
export const acquireRequestSlot = (
  _priority: RequestPriority = 'normal'
): Promise<void> => Promise.resolve()

/**
 * 释放请求槽位。
 *
 * 保留空操作兼容旧调用点，避免无关业务代码重构。
 * @param _priority 请求优先级，保留用于兼容旧调用点。
 */
export const releaseRequestSlot = (
  _priority: RequestPriority = 'normal'
): void => undefined
